import React, { lazy } from 'react';
import { PackageOpen, Check, Clock, Zap, Lock, ShieldCheck } from 'lucide-react';
import { SectionHeader, Button } from '../ui/Shared';
import { useCountdown } from '../../hooks/useCountdown';
export function OfferSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const includes = [{
    title: 'Reflujo Cero en 72h',
    desc: 'El protocolo completo de ajuste digestivo.'
  }, {
    title: 'Protocolo Anti-Ardor',
    desc: 'Secuencia práctica para cortar el ciclo de acidez.'
  }, {
    title: 'Rutina nocturna anti-reflujo',
    desc: 'Cómo cenar y dormir sin subida de ácido.'
  }, {
    title: 'Guía de comidas seguras',
    desc: 'Comer con menos inflamación y presión.'
  }, {
    title: 'Plan de Rescate para Crisis',
    desc: 'Pasos claros cuando el reflujo ataca.'
  }];
  return <section id="oferta" className="py-24" data-id="element-270">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-271">
        <SectionHeader tag="Tu oferta completa" title="Haz cuentas" data-id="element-272" />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-12 items-start" data-id="element-273">
          {/* Left Card */}
          <div className="fade-up bg-surface rounded-2xl p-8 md:p-10 border border-white/10" data-id="element-274">
            <h3 className="text-xl font-bold mb-6 text-text-light flex items-center" data-id="element-275">
              <PackageOpen className="w-5 h-5 text-accent mr-2.5" data-id="element-276" />
              Incluido en tu acceso inmediato
            </h3>
            <ul className="space-y-0" data-id="element-277">
              {includes.map((item, idx) => <li key={idx} className="flex items-start gap-3 py-3 border-b border-white/5 last:border-none text-[15px] text-text-muted" data-id="element-278">
                  <Check className="w-4 h-4 text-accent mt-1 shrink-0" data-id="element-279" />
                  <div data-id="element-280">
                    <strong className="text-text-light" data-id="element-281">{item.title}</strong>
                    <br data-id="element-282" />
                    {item.desc}
                  </div>
                </li>)}
            </ul>
          </div>

          {/* Right Card (Sticky) */}
          <div className="scale-in bg-gradient-to-br from-secondary to-[#0F1A2E] rounded-2xl p-8 md:p-10 border border-accent/40 lg:sticky lg:top-24" data-id="element-283">
            <div className="flex justify-center mb-8" data-id="element-284">
              <img src="https://i.postimg.cc/9MBfVQ1x/libro-principal.webp" alt="Guía digital Reflujo Cero en 72h — Eliminar reflujo ácido y agrura nocturna" width={320} height={427} loading="lazy" decoding="async" className="w-72 md:w-80 h-auto object-contain drop-shadow-[0_16px_40px_rgba(232,160,32,0.3)] rounded-md" data-id="element-285" />
            </div>
            <div className="flex items-baseline gap-4 mb-1" data-id="element-286">
              <span className="price-struck text-2xl md:text-3xl font-bold font-playfair" data-id="element-287">
                120 USD
              </span>
              <span className="text-sm text-text-muted" data-id="element-288">Precio normal</span>
            </div>
            <div className="price-glow font-playfair text-6xl md:text-[84px] font-black text-gradient-gold leading-none mb-1" data-id="element-289">
              12 USD
            </div>
            <p className="text-sm text-accent font-semibold mb-7" data-id="element-290">
              🔥 Precio especial de lanzamiento
            </p>

            <div className="bg-danger/10 border border-danger/20 rounded-lg p-4 mb-6 flex flex-col items-center text-center" data-id="element-291">
              <div className="flex items-center gap-2 text-sm text-[#FC8181] font-semibold mb-3" data-id="element-292">
                <Clock className="w-4 h-4" data-id="element-293" />
                <span data-id="element-294">⏰ Esta oferta expira en:</span>
              </div>
              <div className="flex gap-2 font-playfair text-2xl font-black text-danger mb-2" data-id="element-295">
                <div className="bg-danger/20 rounded px-3 py-1 min-w-[3rem]" data-id="element-296">
                  {hours}
                </div>
                <span data-id="element-297">:</span>
                <div className="bg-danger/20 rounded px-3 py-1 min-w-[3rem]" data-id="element-298">
                  {minutes}
                </div>
                <span data-id="element-299">:</span>
                <div className="bg-danger/20 rounded px-3 py-1 min-w-[3rem]" data-id="element-300">
                  {seconds}
                </div>
              </div>
              <span className="text-xs text-text-muted mt-1" data-id="element-301">
                Después de este tiempo, el precio vuelve a 120 USD
              </span>
            </div>

            <div className="flex justify-center gap-6 mt-4 mb-4" data-id="element-302">
              <span className="flex items-center gap-1.5 text-text-muted text-xs font-medium" data-id="element-303">
                <Lock className="w-3.5 h-3.5 text-accent" data-id="element-304" /> Pago Seguro
              </span>
              <span className="flex items-center gap-1.5 text-text-muted text-xs font-medium" data-id="element-305">
                <ShieldCheck className="w-3.5 h-3.5 text-accent" data-id="element-306" /> Garantía 7D
              </span>
            </div>

            {/* Trust badges */}
            <div className="bg-white/5 border border-white/10 rounded-lg p-4 mt-4 mb-4" data-id="element-307">
              <div className="flex items-center justify-center gap-2 mb-3" data-id="element-308">
                <ShieldCheck className="w-4 h-4 text-success" data-id="element-309" />
                <span className="text-xs font-semibold text-success" data-id="element-310">
                  Conexión cifrada SSL 256-bit
                </span>
              </div>
              <div className="flex items-center justify-center gap-4 flex-wrap opacity-70" data-id="element-311">
                <span className="text-[11px] font-bold text-text-muted bg-white/10 rounded px-2 py-1" data-id="element-312">
                  VISA
                </span>
                <span className="text-[11px] font-bold text-text-muted bg-white/10 rounded px-2 py-1" data-id="element-313">
                  MASTERCARD
                </span>
                <span className="text-[11px] font-bold text-text-muted bg-white/10 rounded px-2 py-1" data-id="element-314">
                  AMEX
                </span>
                <span className="text-[11px] font-bold text-text-muted bg-white/10 rounded px-2 py-1" data-id="element-315">
                  PAYPAL
                </span>
                <span className="text-[11px] font-bold text-text-muted bg-white/10 rounded px-2 py-1" data-id="element-316">
                  PIX
                </span>
              </div>
              <p className="text-[11px] text-text-muted text-center mt-3 leading-relaxed" data-id="element-317">
                Procesado por{' '}
                <strong className="text-text-light" data-id="element-318">Hotmart</strong> —
                Plataforma líder mundial en productos digitales con más de 35
                millones de usuarios
              </p>
            </div>

            <p className="text-xs text-text-muted text-center mt-2 leading-relaxed" data-id="element-319">
              Acceso instantáneo al PDF. Lee en tu celular, tablet o
              computadora.
            </p>
          </div>
        </div>
      </div>
    </section>;
}